import React from 'react';

import ChatTabHolder from 'react/chat/ChatTabHolder';
import withDefaultProps from 'functions/withDefaultProps';

export default function ChatTabContainerComponent(incomingProps) {
	const props = withDefaultProps(incomingProps, defaultProps);
	const { active, displayStyle, chatRoomGroups, onChatWasSelected, showAddNewChatButton } = props;
	if(!active) {
		return null;
	}
	return (
		<div className={`chat_groups chat_entries ${displayStyle ? displayStyle : ''}`}>
			{chatRoomGroups.map((chatGroup) => ( // THERE IS TYPICALLY ONLY ONE CHAT ROOM GROUP
				<ChatTabHolder
					displayStyle={displayStyle}
					onChatWasSelected={onChatWasSelected}
					chats={chatGroup.chats}
					title={chatGroup.title}
					key={chatGroup.type}
					sortable={false && chatGroup.sortable}
					showAddNewChatButton={showAddNewChatButton}
				/>
			))}
		</div>
	);
}

const defaultProps = {
	displayStyle: 'vertical',
	showAddNewChatButton: true,
};